import { ThemeEvents } from '@theme/events';

class SellingPlanSelector extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.form = document.querySelector(`#${this.dataset.formId}`);
    this.fieldset = this.querySelector('.subscription-options');
    this.closestSection = this.closest('.shopify-section, dialog');

    if (!this.form) return console.error('SellingPlanSelector: Form not found.');

    this.addToCartBtn = this.form.querySelector('button[name="add"]');
    this.inputPropertiesSellingPlanName = this.querySelector('input[name="properties[_selling_plan_name]"]');
    this.inputQuantity = this.querySelector('input[name="quantity"]');

    this.boundOnVariantUpdate = this.onVariantUpdate.bind(this)
    this.boundOnChange = this.onChange.bind(this)

    if (!this.fieldset) return;
    this.fieldset.addEventListener('change', this.boundOnChange);

    if (!this.closestSection) return;
    this.closestSection.addEventListener(ThemeEvents.variantUpdate, this.boundOnVariantUpdate);
  }

  disconnectedCallback() {
    if (this.closestSection) {
      this.closestSection.removeEventListener(ThemeEvents.variantUpdate,this.boundOnVariantUpdate);
    }

    if (this.fieldset) {
      this.fieldset.addEventListener('change', this.boundOnChange);
    }
  }

  onChange(event) {
    const target = event.target;
    if (target && target.name === 'selling_plan' && target.type === 'radio') {
      this.updateSellingPlanParam();
      this.updateButtonText();
      this.updateProperties();
      this.updateQuantity();
    }
  }

  isOnProductPage = () => {
    return (
      this.dataset.templateProductMatch === 'true' &&
      !this.closest('product-card') &&
      !this.closest('quick-add-dialog')
    );
  }

  onVariantUpdate = (event) => {
    this.currentVariant = event.detail?.resource || null;
    this.updateOption(event);
    this.updateSellingPlanParam();
    this.updateLinkText();
  }

  updateOption = (event) => {
    const oldFieldset = this.fieldset
    const newFieldset = event?.detail?.data?.html.querySelector('.subscription-options');

    if (!(oldFieldset instanceof HTMLFieldSetElement)) {
      throw new Error('oldFieldset must be HTMLFieldSetElement');
    }

    if (!(newFieldset instanceof HTMLFieldSetElement)) {
      throw new Error('newFieldset must be HTMLFieldSetElement');
    }

    const oldOptions = Array.from(oldFieldset.querySelectorAll('.subscription-option'));
    const newOptions = Array.from(newFieldset.querySelectorAll('.subscription-option'));

    const count = Math.min(oldOptions.length, newOptions.length);

    for (let i = 0; i < count; i++) {
      const oldOption = oldOptions[i];
      const newOption = newOptions[i];

      const oldInput = oldOption.querySelector('input[type="radio"][name="selling_plan"]');
      const newInput = newOption.querySelector('input[type="radio"][name="selling_plan"]');

      if (oldInput && newInput) {
        oldInput.value = newInput.value;
        oldInput.dataset.addToCartText = newInput.dataset.addToCartText;
        oldInput.dataset.addToCartOneTimeText = newInput.dataset.addToCartOneTimeText;
        oldInput.dataset.addToCartOneTimeTextAdditional = newInput.dataset.addToCartOneTimeTextAdditional;
        oldInput.dataset.sellingPlanName = newInput.dataset.sellingPlanName;
      }

      const oldCard = oldOption.querySelector('.subscription-option__card');
      const newCard = newOption.querySelector('.subscription-option__card');

      if (oldCard && newCard) {
        oldCard.innerHTML = newCard.innerHTML;
      }
    }

    this.updateButtonText();
  }

  updateButtonText = () => {
    const input = this.getCheckedInput();

    if (!input) return;

    const addToCartText = input.getAttribute('data-add-to-cart-text') || '';
    const textElement = this.addToCartBtn.querySelector('.add-to-cart-text');


    setTimeout(() => {
      if (textElement) {
        textElement.innerHTML = addToCartText;
      } else {
        this.addToCartBtn.innerHTML = addToCartText;
      }
    }, 0);
  }

  updateLinkText = () => {
    const input = this.getCheckedInput();

    if (!input) return;

    const addToCartText = input.getAttribute('data-add-to-cart-one-time-text') || '';
    const quickAddToCartBtn = this.closestSection.querySelector('quick-add-component button[name="add"]');
    const textElement = quickAddToCartBtn.querySelector('.add-to-cart-text');

    setTimeout(() => {
      if (textElement) {
        textElement.innerHTML = addToCartText;
      } else {
        quickAddToCartBtn.innerHTML = addToCartText;
      }
    }, 0);

    const addToCartTextAdditional = input.getAttribute('data-add-to-cart-one-time-text-additional') || '';
    const textElementAdditionalInfo = this.closestSection.querySelector('quick-add-component .quick-add-link--additional-info');

    if (textElementAdditionalInfo) textElementAdditionalInfo.textContent = addToCartTextAdditional;
  }

  getCheckedInput = () => {
    return this.querySelector('input[name="selling_plan"]:checked') || null;
  }

  getCheckedSellingPlanValue = () => {
    const input = this.getCheckedInput();
    return input ? input.value : null;
  }

  updateSellingPlanParam = () => {
    if (!this.isOnProductPage()) return;

    const value = this.getCheckedSellingPlanValue();

    if (!value) return;

    const url = new URL(window.location.href);
    const params = url.searchParams;

    params.set('selling_plan', value);

    window.history.replaceState({}, '', `${url.pathname}?${params.toString()}`);
  }

  updateProperties = () => {
    const input = this.getCheckedInput();

    if (!input) return;

    this.inputPropertiesSellingPlanName.value = input.getAttribute('data-selling-plan-name') || '';
  }

  updateQuantity = () => {
    const input = this.getCheckedInput();

    if (!input) return;

    this.inputQuantity.value = input.getAttribute('data-quantity-size') || 1;
  }
}

if (!customElements.get('selling-plan-selector')) {
  customElements.define('selling-plan-selector', SellingPlanSelector);
}